// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-42304504] .app_modal_active{max-height:none}.actions[data-v-42304504]{display:flex;align-items:center;justify-content:flex-start;gap:.75em;padding-top:.75em}", ""]);
// Exports
module.exports = exports;
